export function getErrorMessage(err: unknown, fallback = '操作失败'): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const res = (err as { response?: { data?: { error?: unknown; message?: unknown } } }).response;
    const msg = res?.data?.error || res?.data?.message;
    if (typeof msg === 'string') return msg;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
